import VastuCarousel from "./VastuCarousel";
import VastuImg from "./VastuImg";
import VastuImage from "./vastu.jpg"; // Adjust path as needed
import "./Vastu.css";

export default function Interior() {
  return (
    <div
      className="parallax-container"
      style={{ backgroundImage: `url(${VastuImage})` }}
    >
      <div className="content">
        <VastuImg />
        <VastuCarousel />
      </div>
    </div>
  );
}
